module.exports = __webpack_public_path__ + "static/media/photo_mobile.1aaeb9dd.png";